module.exports = __webpack_public_path__ + "assets/InteriorAngles.4f58163cd244b31db7a84cf30ded040e.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/InteriorAngles.gmt
// module id = 959
// module chunks = 0